export default "__VITE_ASSET__DfALXYA5__"